import * as React from 'react';

const WhatsAppIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={14}
    height={14}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#whatsapp-clip)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.938 2.03451C10.6278 0.723241 8.88538 0.000737017 7.02902 0C3.20403 0 0.0909673 3.11188 0.0894366 6.93688C0.0889263 8.15955 0.408489 9.35307 1.01573 10.4051L0.03125 14L3.71002 13.0353C4.72359 13.588 5.8648 13.8792 7.02624 13.8797H7.0291C10.8537 13.8797 13.967 10.7674 13.9686 6.94242C13.9693 5.08876 13.2482 3.34577 11.938 2.03451ZM7.0291 12.708H7.02673C5.99177 12.7076 4.97663 12.4297 4.09108 11.9043L3.88044 11.7793L1.69744 12.3518L2.28013 10.2241L2.14297 10.0059C1.56561 9.08788 1.26065 8.02678 1.2611 6.93732C1.26237 3.75813 3.84985 1.17167 7.03138 1.17167C8.57196 1.17225 10.0202 1.77281 11.1091 2.86269C12.1981 3.95257 12.7975 5.40128 12.7969 6.94196C12.7956 10.1214 10.2082 12.708 7.0291 12.708ZM10.1929 8.3896C10.0195 8.30284 9.16699 7.88348 9.00804 7.82563C8.84911 7.76778 8.73353 7.73887 8.61792 7.91241C8.50234 8.08593 8.17004 8.47638 8.06886 8.59205C7.96773 8.70774 7.86659 8.72222 7.69319 8.63544C7.5198 8.54868 6.9611 8.36565 6.29879 7.7751C5.78335 7.3155 5.43532 6.74781 5.33418 6.57429C5.23304 6.40075 5.32343 6.30692 5.41023 6.22052C5.48822 6.14285 5.58362 6.01807 5.67032 5.91683C5.757 5.81561 5.7859 5.74331 5.84369 5.62764C5.9015 5.51194 5.8726 5.41071 5.82925 5.32395C5.7859 5.23719 5.43914 4.38399 5.29463 4.03693C5.1539 3.69892 5.01093 3.74465 4.9045 3.73936C4.80347 3.73433 4.68776 3.73326 4.57218 3.73326C4.45658 3.73326 4.26874 3.77665 4.10979 3.95017C3.95086 4.12371 3.50294 4.54307 3.50294 5.39625C3.50294 6.24943 4.12425 7.07368 4.21095 7.18938C4.29763 7.30507 5.43362 9.05594 7.17302 9.80677C7.58671 9.98535 7.9097 10.092 8.16151 10.1719C8.57691 10.3038 8.9549 10.2852 9.25368 10.2406C9.58681 10.1908 10.2795 9.82125 10.4241 9.41634C10.5686 9.01143 10.5686 8.66437 10.5252 8.59207C10.4819 8.51977 10.3663 8.47638 10.1929 8.3896Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="whatsapp-clip">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default WhatsAppIcon;
